import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';

export default function ErrorPage() {
  const error = useRouteError();
  
  let errorMessage: string;
  let statusText: string;
  
  if (isRouteErrorResponse(error)) {
    errorMessage = error.data?.message || '页面未找到';
    statusText = error.statusText;
  } else if (error instanceof Error) {
    errorMessage = error.message;
    statusText = '错误';
  } else {
    errorMessage = '发生了未知错误';
    statusText = '错误';
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-md">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            {statusText}
          </h1>
          <p className="text-gray-600 mb-6">
            {errorMessage}
          </p>
          <div className="space-x-4">
            <Link
              to="/"
              className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
            >
              返回首页
            </Link>
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
            >
              返回上一页
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
